var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hpanel" }, [
    _c("div", { staticClass: "panel-body" }, [
      _c("div", { staticClass: "text-center" }, [
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _c("h2", [_vm._v("商品が登録されていません。")]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c(
          "h2",
          [
            _vm._v("\n        ["),
            _c(
              "router-link",
              {
                attrs: {
                  to: { name: "ProductsNew", params: { tab: "add-by-amazon" } }
                }
              },
              [_vm._v("Amazonから追加")]
            ),
            _vm._v("]メニューより商品登録を行って下さい。\n      ")
          ],
          1
        ),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("br")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15925ce8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15925ce8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/productsNew/ProductsNewNoItem.vue
// module id = null
// module chunks = 